'use strict'

import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import router from './../router';
import { Message } from 'element-ui';
import config from "@/config/index.js"
import md5 from '../utils/md5';
import {
    singleMessage
} from '@/utils/resetMessage';
import { getToken } from './../utils/libs/auth'

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;

// 带上session
axios.defaults.withCredentials = false;
// 默认地址
//axios.defaults.baseURL = "";
// 超时时间
axios.defaults.timeout = 1500000;

//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// http请求拦截器
axios.interceptors.request.use(request => {
    if (request.url.indexOf("openai.") >= 0) {
        return request;
    }
    // Do something with request data
    if (request.method == "post") {
        request.transData = changeOptData(request.data, request.url, request.method);
        request.data = qs.stringify(request.transData);
    } else if (request.method == "get") {
        if (request.url.split("?").length > 1) {
            let params = request.url.split("?")[1].split("&") || request.params;
            let obj = {};
            params.map(item => obj[item.split("=")[0]] = item.split("=")[1]);
            request.url = request.url.split("?")[0] + "?" + qs.stringify(changeOptData(obj, request.url, request.method));
            if (request.url.indexOf("topnews.") >= 0) {
                request.transData = changeOptData(obj, request.url, request.method);
            }
        } else if (request.params) {
            request.params = changeOptData(request.params, request.url, request.method);
        } else {
            request.url = request.url.split("?")[0] + "?" + qs.stringify(changeOptData({}, request.url, request.method));
            if (request.url.indexOf("topnews.") >= 0) {
                request.transData = changeOptData({}, request.url, request.method);
            }
        }
    }
    if (request.url.indexOf("api.media.dingxinwen.cn") >= 0 || request.url.indexOf("nm.dingnews.net") >= 0) {
        request.headers["App-Id"] = request.url.split("&orgId=")[1].split("&")[0];
    }
    if (request.url.indexOf("topnews.") >= 0) {
        if (request.method != 'get') {
            request.headers = {};
            request.headers.authorization = request.transData.authorization;
            request.headers.app_id = request.transData.app_id;
            request.headers.timestamp = request.transData.timestamp;
            request.headers.sign = request.transData.sign;
            request.data = request.transData["body"];
        } else {
            request.headers = {};
            request.headers.authorization = request.transData.authorization;
            request.headers.app_id = request.transData.app_id;
            request.headers.timestamp = request.transData.timestamp;
            request.headers.sign = request.transData.sign;
            delete request.transData.authorization;
            delete request.transData.app_id;
            delete request.transData.timestamp;
            delete request.transData.sign;
            request.url = request.url.split("?")[0] + (qs.stringify(request.transData) ? ("?" + qs.stringify(request.transData)) : "");
        }
    }
    return request
}, error => {
    // Do something with request error
    Message.error('请求错误');
    return Promise.reject(error)
});

// http响应拦截器
axios.interceptors.response.use(response => {
    // Do something with response data
    if (response.data.code == -1) {
        localStorage.setItem("tokenExpire", 1);
        router.push({ path: "/login" });
        singleMessage.error('登录过期，请重新登录');
        response.data.code = 0;
    }
    return response
}, error => {
    // Do something with response error
    Message.error('网络错误，请检查网络');
    return Promise.reject(error)
});

function changeOptData(option, url, method) {
    if (url.indexOf("topnews.") >= 0 && method == 'post') {
        delete option.token;
        let data = {};
        data["body"] = option;
        let sign = [];
        data.timestamp = parseInt(new Date().getTime() / 1000);
        data.app_id = config.app_id;
        let token = getToken() || "";
        data.authorization = token;
        let mdKey = "";
        Object.keys(data).forEach((key) => {
            sign.push(key);
        });
        sign.sort().forEach((item, index) => {
            mdKey += `${item}=${item == "body" ? JSON.stringify(data[item]) : data[item]}`;
        });
        data.sign = md5(`${mdKey}${config.app_secret}`);
        return data;
    } else {
        let data = {
            ...option
        };
        let timestamp = parseInt(new Date().getTime() / 1000);
        let token = getToken() || "";
        let sign = [];
        data.timestamp = timestamp;
        data.app_id = config.app_id;
        if (url.indexOf("topnews.") >= 0) {
            data.authorization = token || "";
        } else {
            token ? data.token = token : "";
        }
        let mdKey = '';
        Object.keys(data).forEach((key) => {
            sign.push(key);
        });
        sign.sort().forEach((item, index) => {
            if (item != "uploadFile") {
                mdKey += `${item}=${data[item]}`;
            }
        });
        data.sign = md5(`${mdKey}${config.app_secret}`);
        return data;
    }
};

export default axios